export const USER = "@userinfo";

export const compareData = (dtInicial, operador, dtFinal) => {

    let dt1 = new Date(dtInicial);
    let dt2 = new Date(dtFinal);

    let result = false;

    switch (operador) {
        case '=':
            if (dt1.getTime() === dt2.getTime()) {
                result = true;
            } else {
                result = false;
            }

            break;
    
        case '<':
            if (dt1.getTime() < dt2.getTime()) {
                result = true;
            } else {
                result = false;
            }
            break;
    
        case '>':
            if (dt1.getTime() > dt2.getTime()) {
                result = true;
            } else {
                result = false;
            }
            break;
    
        case '<=':
            if (dt1.getTime() <= dt2.getTime()) {
                result = true;
            } else {
                result = false;
            }
            break;
    
        case '>=':
            if (dt1.getTime() >= dt2.getTime()) {
                result = true;
            } else {
                result = false;
            }
            break;
    
        case '!=':
            if (dt1.getTime() !== dt2.getTime()) {
                result = true;
            } else {
                result = false;
            }
            break;
    
        default:
            break;
    }

    return result;
}

export const isTotvs = () => {
    const user = JSON.parse(localStorage.getItem(USER));

    if (
        user?.contrato.agro_plan_config.agro_plan_id === 9 ||
        user?.contrato.agro_plan_config.agro_plan_id === 10 ||
        user?.contrato.agro_plan_config.agro_plan_id === 11  ) {
        return true;
    }

    return false;
}

export const isTotvsProtheus = () => {
    const user = JSON.parse(localStorage.getItem(USER));

    if (
        user?.contrato.agro_plan_config.agro_plan_id === 9 ||
        user?.contrato.agro_plan_config.agro_plan_id === 10) {
        return true;
    }

    return false;
}

export const isOmie = () => {
    const user = JSON.parse(localStorage.getItem(USER));
    return user?.contrato.agro_plan_config.agro_plan_id === 11;
}

export const UFS_NF_APOS_RECEITA = ['GO', 'DF'];

export const isNfAposReceita = (uf) => UFS_NF_APOS_RECEITA.includes(String(uf || '').trim());

const pad2 = (n) => String(n).padStart(2, '0');

export const dataEmissaoToYmd = (value) => {
    if (!value) return null;

    if (value instanceof Date && !isNaN(value.getTime())) {
        return `${value.getUTCFullYear()}-${pad2(value.getUTCMonth() + 1)}-${pad2(value.getUTCDate())}`;
    }

    const raw = String(value).trim();
    if (!raw) return null;

    const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}`;

    const br = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    if (br) return `${br[3]}-${pad2(br[2])}-${pad2(br[1])}`;

    const dmy = raw.match(/^(\d{1,2})-(\d{1,2})-(\d{4})/);
    if (dmy) return `${dmy[3]}-${pad2(dmy[2])}-${pad2(dmy[1])}`;

    return null;
};

export const isPrazoNfAposReceitaExpirado = (dataEmissao, dias = 7) => {
    const ymd = dataEmissaoToYmd(dataEmissao);
    if (!ymd) return false;

    const [ano, mes, dia] = ymd.split('-').map(Number);
    const inicio = Date.UTC(ano, mes - 1, dia);
    const agora = new Date();
    const hoje = Date.UTC(agora.getFullYear(), agora.getMonth(), agora.getDate());
    const diffDias = Math.floor((hoje - inicio) / (1000 * 60 * 60 * 24));
    return diffDias > dias;
};

export const orgaoHomologacaoNfAposReceita = (uf) => {
    if (uf === 'DF') return 'SIAGRO DF';
    if (uf === 'GO') return 'SIDAGO';
    return '';
};

export const pathExportarReceita = (uf, id) => {
    if (uf === 'DF') return `/siagrodf/exportar_receita/${id}`;
    if (uf === 'GO') return `/sidago/exportar_receita/${id}`;
    return null;
};

export const pathExportarNf = (uf, id) => {
    if (uf === 'DF') return `/siagrodf/exportar_nf/${id}`;
    if (uf === 'GO') return `/sidago/exportar_nf/${id}`;
    return null;
};

export const base64UrlEncode = (string) => {
    return Buffer.from(string)
    .toString('base64')
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
}